import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Transition} from 'semantic-ui-react'
import ReactPageScroller from 'react-page-scroller';

import {loadResourcesDepartment} from '../utils/homeUtils'
import http from '../utils/http-common'
import {setMenuVisible, setPageVisible} from '../actions'
import DepartmentDetail from './DepartmentDetail'

import styles from './Department.module.scss'
import MenuIconDesktop from '../components/MenuIconDesktop';


class Department extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPageVisible: false,
            language: "",
            steps: [false, false],
            currentPage: 0,
            productions: [{
                id: 1,
                name: "",
                year: "",
                order: 1,
                description: "",
                awards: [
                    {}
                ],
                images: []
            }]
        }
        this.handlePageOnChange = this.handlePageOnChange.bind(this);
        this.setStepVisible = this.setStepVisible.bind(this);
        this.getLanguage = this.getLanguage.bind(this);
    }

    componentDidMount() {
        loadResourcesDepartment();
        this.getLanguage();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.productions !== this.state.productions) {
            setTimeout(() => {
                this.setState({
                    isPageVisible: true,
                });
            }, 0);
        }

        if (prevProps.language !== this.props.language) {
            this.getLanguage();
        }
    }

    getLanguage() {
        http.get("/api/v1/departments?language=" + localStorage.getItem("language"))
            .then(res=>{
                console.log(res.data);
                this.setState({productions: res.data});
            }).catch(error=>{console.log(error)});
    }

    setStepVisible(index, visible) {
        const steps = [...this.state.steps];
        steps[index] = visible;
        this.setState({steps: steps});
    }

    handlePageOnChange = number => {
        this.setState({currentPage: number});
    }

    getLanguageClass = () => {
        switch(this.props.language) {
            case "EN":
                return styles.en;
            default:
                return '';
        }
    }

    render() {
        return (
            <>
                <div className={`department ${styles.home} ${styles.desktop} ${this.getLanguageClass()}`}>
                    <Transition visible={this.state.isPageVisible} animation='fade' duration={500}>
                        <MenuIconDesktop />
                    </Transition>
                    <Transition visible={this.state.isPageVisible} animation='fade' duration={500} onShow={() => {
                        this.setStepVisible(0, true)
                    }}>
                        <div className={styles.page_wrapper}>
                            <div className={styles.page_number}>
                                <div
                                    className={styles.current_page_number}>{(this.state.currentPage + 1).toString().padStart(2, '0')}</div>
                                <div className={styles.page_number_divider}>
                                    <hr/>
                                </div>
                                <div
                                    className={styles.total_page_number}>{(this.state.productions.length).toString().padStart(2, '0')}</div>
                            </div>
                            <Transition visible={this.state.steps[1]} animation='fade' duration={1000}>
                                <div className={styles.title}>
                                    <div className={styles.title_word}>Department</div>
                                    <div className={styles.subtitle_block}>
                                        <div className={styles.subtitle_word}>OUTLAND Film Production</div>
                                    </div>
                                </div>
                            </Transition>

                            <Transition visible={this.state.steps[0]} animation='fade' duration={1000} onShow={() => {
                                this.setStepVisible(1, true)
                            }}>
                                {this.state.productions.length > 0 ? (
                                    this.state.productions.length === 1 ? <DepartmentDetail key={1} production={this.state.productions[0]}  showScrollDown={false}/> :
                                  <ReactPageScroller containerWidth="100%" containerHeight="100%"
                                                     pageOnChange={this.handlePageOnChange}>
                                      {
                                          this.state.productions.map((production, index) => {
                                              return (<DepartmentDetail key={index} production={production} showScrollDown={true}/>);
                                          })
                                      }
                                  </ReactPageScroller>
                                 ) : null
                                }

                            </Transition>
                        </div>
                    </Transition>
                </div>

                <div className={`department ${styles.home} ${styles.mobile} ${this.getLanguageClass()}`}>
                    <div className={styles.menu_wrapper}>
                        <div className={styles.menu} onClick={() => {
                            this.props.setMenuVisible(true)
                        }}>
                            <span className={styles.menu_icon}><div className={styles.menu_icon_line}></div></span>
                            <span className="vertical_center">OUTLAND Film Production</span>
                        </div>
                    </div>
                    <div className={styles.page_wrapper}>
                        <div className={styles.page_number}>
                            <div
                                className={styles.current_page_number}>{(this.state.currentPage + 1).toString().padStart(2, '0')}</div>
                            <div className={styles.page_number_divider}>
                                <hr/>
                            </div>
                            <div
                                className={styles.total_page_number}>{(this.state.productions.length).toString().padStart(2, '0')}</div>
                        </div>
                        {this.state.productions.length > 0 ? (
                          this.state.productions.length === 1 ? <DepartmentDetail key={1} production={this.state.productions[0]}/> :
                            <ReactPageScroller containerWidth="100%" containerHeight="100%"
                                               pageOnChange={this.handlePageOnChange}>
                                {
                                    this.state.productions.map((production, index) => {
                                        return (<DepartmentDetail key={index} production={production}/>);
                                    })
                                }
                            </ReactPageScroller>
                        ) : null
                        }
                    </div>
                    {this.state.productions.length > 0 ? (
                    <div className={styles.scroll_down}>
                        <div className={styles.text}>SCROLL</div>
                        <div className={styles.arrow_block}>
                            <div className={`arrow down ${styles.arrow} ${styles.top}`}></div>
                            <div className={`arrow down ${styles.arrow} ${styles.down}`}></div>
                        </div>
                    </div>
                    ) : null }
                </div>
            </>
        )
    }

};

const mapStateToProps = state => {
    return {
        isPageVisible: state.isPageVisible,
        language: state.language
    };
};

export default connect(mapStateToProps, {setMenuVisible, setPageVisible})(Department);
